export const paymentAccounts = {
  // Stripe وWompi تكاملان اثنان، لا خياران لتكامل واحد: لكل منهما شاشته
  // وترويسته. وtagline هو السطر الذي يحدّد الموقع (أين يحصّل وبأي وسائل).
  header: {
    stripe: {
      title: "التحصيل عبر Stripe",
      tagline: "البطاقات الدولية · إسبانيا ومعظم الدول",
      description:
        "اربط حسابًا واحدًا أو أكثر من Stripe وحدّد الحساب الذي يحصّل مدفوعات كل إعلان.",
    },
    wompi: {
      title: "التحصيل عبر Wompi",
      tagline: "كولومبيا · PSE وNequi والبطاقات الكولومبية",
      description:
        "اربط حسابًا واحدًا أو أكثر من Wompi وحدّد الحساب الذي يحصّل مدفوعات كل إعلان.",
    },
    bold: {
      title: "المدفوعات عبر Bold",
      tagline: "كولومبيا وبيرو · PSE وNequi وBancolombia والبطاقات",
      description:
        "اربط حسابًا واحدًا أو أكثر من Bold واختر الحساب الذي يحصّل لكل إعلان.",
    },
    redsys: {
      title: "المدفوعات عبر Redsys",
      tagline: "إسبانيا · نقطة البيع الافتراضية لبنكك",
      description:
        "اربط نقطة البيع الافتراضية لبنكك واختر الحساب الذي يحصّل به كل إعلان. تصل الأموال مباشرة إلى حسابك البنكي.",
      card: "نقطة البيع الافتراضية لبنكك (إسبانيا)",
    },
  },

  // Wompi حيث لا ينطبق. بوابة الدفع تحدّدها دولة الإعلان لا دولة المالك،
  // ولهذا الحديث هنا عن أماكن الإقامة لا عنك.
  notAvailable: {
    title: "Wompi مخصّص لأماكن الإقامة في كولومبيا",
    text: "يحصّل Wompi بالبيزو الكولومبي عبر PSE وNequi والبطاقات الكولومبية. ليس لديك أي مكان إقامة هناك، فلا يوجد ما يُربط هنا.",
    hint: "إذا نشرت مكان إقامة في كولومبيا، ستُفتح هذه الشاشة من تلقاء نفسها.",
    button: "الانتقال إلى {provider}",
  },

  session: {
    title: "انتهت صلاحية جلستك",
    text: "لم يُفقد شيء: حسابات التحصيل لديك ما زالت مربوطة. سجّل الدخول من جديد لعرضها.",
    button: "تسجيل الدخول من جديد",
  },

  status: {
    ready: "جاهز",
    incomplete: "غير مكتمل",
    unverified: "غير موثّق",
  },

  environment: {
    test: "تجريبي",
  },

  accounts: {
    card: {
      title: "حساباتك في {provider}",
      subtitle: "اربط حسابات جديدة وتحقّق مما إذا كانت جاهزة للتحصيل.",
    },
    searchPlaceholder: "ابحث عن حساب بالاسم…",
    newButton: "ربط حساب {provider}",
    noName: "بدون اسم",
    fallbackName: "الحساب رقم {id}",
    defaultBadge: "رئيسي",
    listingsCount: "إعلان واحد | {count} إعلانات",
    empty: {
      none: "لم تربط أي حساب {provider} بعد.",
      noMatch: "لا يوجد حساب يطابق البحث.",
    },
    actions: {
      edit: "تعديل",
      setDefault: "اجعله الرئيسي",
      isDefault: "هو الرئيسي بالفعل",
      resume: "إكمال التسجيل",
      verify: "تحقّق",
      disconnect: "فصل",
    },
  },

  assign: {
    card: {
      title: "التوزيع حسب الإعلان",
      subtitle: "اختر الإعلانات التي يحصّلها كل حساب من حسابات {provider}.",
    },
    searchPlaceholder: "ابحث عن إعلان بالاسم…",
    filter: {
      all: "الكل",
      unassigned: "غير مسندة",
      notReady: "لا يمكنه التحصيل",
      other: "يحصّل عبر {provider}",
    },
    // بلا حساب مُسند. عندما يُعرف الحساب الرئيسي يُذكر باسمه، وهذا ما يريد
    // المضيف معرفته: عبر أي حساب يحصّل هذا الإعلان.
    autoOption: "الحساب الرئيسي",
    autoOptionNamed: "الحساب الرئيسي · {name}",
    autoOptionOther: "الحساب الرئيسي في {provider} · {name}",
    otherProvider: "يحصّل عبر {provider} · {name}",
    otherProviderLink: "الإدارة في {provider}",
    notReadyRow: "لا يحصّل",
    notReadyRowTip: "الحساب المسند إلى هذا الإعلان ليس جاهزًا بعد، لذلك لن يتمكن الضيف من الدفع.",
    notReadyAutoRow: "حسابك الرئيسي لا يستطيع التحصيل",
    notReadyAutoRowTip: "يستخدم هذا الإعلان الحساب الرئيسي، وهو ليس جاهزًا بعد. أكمله أو أسند الإعلان إلى حساب آخر.",
    notReadyBanner: "إعلان واحد لا يستطيع التحصيل الآن: حسابه ليس جاهزًا بعد. لن يتمكن الضيوف من الدفع حتى تُكمل ذلك الحساب. | {count} إعلانات لا تستطيع التحصيل الآن: حسابها ليس جاهزًا بعد. لن يتمكن الضيوف من الدفع حتى تُكمل ذلك الحساب.",
    notReadyBannerLink: "عرض هذه الإعلانات",
    defaultSuffix: " (رئيسي)",
    empty: {
      none: "ليس لديك إعلانات بعد.",
      noMatch: "لا يوجد إعلان يطابق عامل التصفية.",
    },
    count: "يظهر {shown} من أصل {total} إعلانًا",
  },

  drawer: {
    newTitle: "ربط حساب {provider}",
    editTitle: "تعديل حساب {provider}",
    subtitle: "أعطه اسمًا واختر الإعلانات التي يحصّلها.",
    closeAria: "إغلاق اللوحة",

    stripe: {
      title: "التسجيل في Stripe",
      subtitle: "سيطلب Stripe بياناتك ثم يعيدك إلى هنا.",
      explain:
        "سننقلك إلى Stripe لإنشاء الحساب بهذا الاسم والتحقق من بياناتك. وعند عودتك يمكنك اختيار الإعلانات التي يحصّلها؛ وإن تركت التسجيل في منتصفه فسيبقى الحساب هنا لتكمله.",
      button: "المتابعة في Stripe",
      connecting: "جارٍ فتح Stripe…",
      resumeTitle: "تسجيل Stripe غير مكتمل",
      resumeSubtitle: "لم تكتمل عملية التحقق لدى Stripe.",
      resumeExplain: "أُنشئ هذا الحساب لكنه لم يُكمل التسجيل في Stripe، لذلك لا يستطيع التحصيل بعد. أكمل من حيث توقفت.",
      resumeButton: "إكمال التسجيل",
    },

    data: {
      title: "بيانات الحساب",
      subtitle: "الاسم لك وحدك: يساعدك على التمييز بين الحسابات.",
      label: "اسم الحساب",
      labelPlaceholder: "مثال: شقق الشاطئ",
      labelHint: "لا يراه الضيف في أي وقت.",
      publicKey: "المفتاح العام",
      privateKey: "المفتاح الخاص",
      privateKeyKept: "يُحتفظ بالمفتاح الحالي",
      privateKeyHint: "اتركه فارغًا للإبقاء على المفتاح المحفوظ.",
      stripeId: "معرّف Stripe",
    },

    listings: {
      title: "الإعلانات التي يحصّلها",
      subtitle: "الإعلانات التي تحددها لن تحصّل عبر حسابها السابق.",
      label: "إعلانات هذا الحساب",
      selectedCount: "تم تحديد {selected} من {total}",
      searchPlaceholder: "ابحث عن إعلان…",
      selectAll: "تحديد الكل",
      clear: "مسح",
      takenBy: "حاليًا في {name}",
      noResults: "لا يوجد إعلان يطابق البحث.",
      hint: "الإعلانات التي لا تحددها في أي حساب تحصّل عبر الحساب الرئيسي.",
      otherHidden: "لا يظهر هنا إعلان واحد يحصّل عبر {provider}: تتم إدارته في شاشته الخاصة. | لا تظهر هنا {count} إعلانات تحصّل عبر {provider}: تتم إدارتها في شاشتها الخاصة.",
    },

    footer: {
      isDefault: "هو الرئيسي بالفعل",
      setDefault: "اجعله الرئيسي",
      disconnect: "فصل",
      cancel: "إلغاء",
      save: "حفظ",
      saving: "جارٍ الحفظ…",
    },
  },

  disconnect: {
    title: "فصل الحساب",
    subtitle: "لن تحصّل عبره بعد الآن.",
    confirm:
      "أنت على وشك فصل «{name}». الحجوزات التي حُصّلت من قبل لن تتأثر، لكن هذا الحساب لن يقبل مدفوعات جديدة.",
    blocked:
      "«{name}» ما زال يحصّل إعلانًا واحدًا. يجب نقله إلى حساب آخر قبل فصله. | «{name}» ما زال يحصّل {count} إعلانات. يجب نقلها إلى حساب آخر قبل فصله.",
    moveLabel: "انقل هذه الإعلانات إلى",
    moveHint: "ننقلها إلى الحساب الذي تختاره ثم نفصل هذا الحساب.",
    cancel: "إلغاء",
    accept: "فصل",
    seeListings: "عرض هذه الإعلانات",
    moveAndDisconnect: "النقل والفصل",
  },

  loading: {
    accounts: "جارٍ تحميل حسابات التحصيل…",
  },

  msg: {
    loadError: "تعذّر تحميل حسابات التحصيل.",
    labelRequired: "أعطِ الحساب اسمًا.",
    publicKeyRequired: "المفتاح العام لـ Wompi ناقص.",
    privateKeyRequired: "المفتاح الخاص لـ Wompi ناقص.",
    saved: "تم حفظ الحساب.",
    saveError: "تعذّر حفظ الحساب.",
    stripeNoUrl: "لم يُعد Stripe رابط التسجيل. حاول مرة أخرى.",
    stripeConnectError: "تعذّر فتح التسجيل في Stripe.",
    verified: "الحساب موثّق.",
    verifiedWithName: "تم توثيق الحساب: {name}.",
    notVerified: "الحساب غير موثّق بعد. راجع المفاتيح.",
    verifyError: "تعذّر التحقق من الحساب.",
    defaultUpdated: "أصبح الآن الحساب الرئيسي.",
    defaultError: "تعذّر تغيير الحساب الرئيسي.",
    disconnected: "تم فصل الحساب.",
    disconnectError: "تعذّر فصل الحساب.",
    movedAndDisconnected: "تم نقل الإعلانات وفصل الحساب.",
    savedNotReady: "انتبه: هذا الحساب لا يستطيع التحصيل بعد ولديه إعلان واحد مسند إليه. أكمله وإلا بقي ذلك الإعلان بلا تحصيل. | انتبه: هذا الحساب لا يستطيع التحصيل بعد ولديه {count} إعلانات مسندة إليه. أكمله وإلا بقيت تلك الإعلانات بلا تحصيل.",
    assignError: "تعذّر تغيير حساب هذا الإعلان.",
  },

  integrations: {
    connectedAccounts: "حساب واحد مرتبط | {count} حسابات مرتبطة",
    notApplicable: "لأماكن الإقامة في كولومبيا",
    notApplicableSpain: "للمنشآت في إسبانيا",
  },

  // Redsys: los tres datos del TPV que da el banco, y el entorno.
  redsys: {
    environment: "البيئة",
    environmentHint: "يعطيك بنكك بيانات للتجربة وأخرى للتحصيل الفعلي. اختر إلى أيهما تنتمي البيانات التي ستكتبها.",
    env: {
      test: "تجريبية",
      prod: "فعلية",
    },
    merchantCode: "رقم التاجر (FUC)",
    merchantCodeHint: "تجده في عقد نقطة البيع أو في وحدة إدارة Redsys. أرقام فقط، عادةً تسعة.",
    terminal: "الطرفية",
    terminalHint: "غالبًا 1. إذا أعطاك البنك عدة أرقام، فاستخدم رقم نقطة البيع الافتراضية.",
    secretKey: "مفتاح التوقيع (SHA-256)",
    secretKeyHint: "في وحدة إدارة Redsys ← بيانات التاجر ← «عرض المفتاح». نتحقق منه مع Redsys عند الحفظ دون خصم أي مبلغ.",
    onlyEuro: "اليورو فقط · يحصّل بـ {currency}",
    onlyEuroTip: "Redsys يحصّل باليورو فقط. اربط هذا المسكن بحساب تحصيل آخر.",
    msg: {
      merchantCode: "رقم التاجر يتكون من أرقام فقط (عادةً تسعة).",
      terminal: "الطرفية رقم من خانة إلى ثلاث خانات (غالبًا 1).",
      secretKey: "مفتاح توقيع Redsys مفقود.",
    },
  },
};
